export const UnreadMessageTypes = ['prompt', 'card', 'form']
